import type { PermissionKey } from '@pm/contracts';

/** Permissions that can produce an action in the server-filtered action inbox. */
export const actionPermissions: readonly PermissionKey[] = [
  'governance.read',
  'governance.manage',
  'governance.publish',
  'reports.read',
  'reports.manage',
  'reports.publish',
  'billing.read',
  'billing.manage',
  'billing.approve',
  'data.quality.read',
  'data.quality.manage',
];
